import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { connect } from 'react-redux';
import { Routes } from 'react-router-dom';
import { selectFundraiser } from '@client/redux/fundraiser/fundraiserSelectors';
import { routeWithSubRoutes } from '@client/shared/utils/routerUtils/routerUtils';
import styles from './donatePage.scss';

class DonatePage extends PureComponent {
  render() {
    const { routes } = this.props;

    return (
      <div className={`${styles.donatePage}`}>
        <Routes>
          {routes && routes.map((route, index) => routeWithSubRoutes(route, index))}
        </Routes>
      </div>
    );
  }
}

DonatePage.propTypes = {
  routes: PropTypes.array,
  fundraiser: ImmutablePropTypes.map,
};

function mapStateToProps(state) {
  return {
    fundraiser: selectFundraiser(state),
  };
}

export default connect(mapStateToProps)(DonatePage);
